import toast from 'react-hot-toast';

export interface ErrorResponse {
  message?: string;
  detail?: string;
  errors?: Record<string, string[]>;
}

export const handleApiError = (error: any, customMessage?: string) => {
  let errorMessage = customMessage || 'An unexpected error occurred';

  // Extract error from Axios response
  if (error?.response?.data) {
    const data = error.response.data as ErrorResponse;

    // Backend sends: { detail: "..." }
    if (data.detail) {
      errorMessage = data.detail;
    }
    // Backend sends: { message: "..." }
    else if (data.message) {
      errorMessage = data.message;
    }
    // Backend sends: { errors: { field: ["error1", "error2"] } }
    else if (data.errors) {
      const errorMessages = Object.entries(data.errors)
        .map(([field, messages]) => `${field}: ${messages.join(', ')}`)
        .join('\n');
      errorMessage = errorMessages;
    }
  } else if (error?.message) {
    errorMessage = error.message;
  }

  // Display toast notification
  toast.error(errorMessage, {
    duration: 5000,
    position: 'top-right'
  });

  console.error('API Error:', error);
  return errorMessage;
};

export const showSuccess = (message: string) => {
  toast.success(message, {
    duration: 3000,
    position: 'top-right'
  });
};

export const showInfo = (message: string) => {
  toast(message, {
    duration: 3000,
    position: 'top-right',
    icon: 'ℹ️'
  });
};

export const showWarning = (message: string) => {
  toast(message, {
    duration: 4000,
    position: 'top-right',
    icon: '⚠️'
  });
};
